var map = {
	"./community/products/among/image.png": "2539",
	"./community/products/chill/image.png": "af1b",
	"./community/products/creepy/image.png": "afdc",
	"./community/products/doge/image.png": "49d8",
	"./community/products/frog/image.png": "3fd0",
	"./community/products/heycatch/image.png": "2420",
	"./community/products/ninja/image.png": "bf23",
	"./community/products/sneaky/image.png": "813d",
	"./community/products/surf/image.png": "858b",
	"./community/products/wake/image.png": "fdb5",
	"./home/products/arabica0/image.png": "5d3a",
	"./home/products/brazilian0/image.png": "67f6",
	"./home/products/colombian0/image.png": "a861",
	"./home/products/columbian0/image.png": "6aac",
	"./home/products/costarika0/image.png": "65a0",
	"./home/products/guatemala0/image.png": "2a47",
	"./home/products/indonesian0/image.png": "d477",
	"./kits/products/1/image.png": "5979",
	"./kits/products/2/image.png": "9719",
	"./kits/products/3/image.png": "2c99",
	"./kits/products/4/image.png": "594c",
	"./kits/products/5/image.png": "4f2b",
	"./taste-test/image.png": "be16"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7204";